import api from '@/api'

const SET_COUNTRIES_GROUPS = 'SET_COUNTRIES_GROUPS'
const ADD_COUNTRIES_GROUP = 'ADD_COUNTRIES_GROUP'
const UPDATE_COUNTRIES_GROUP = 'UPDATE_COUNTRIES_GROUP'
const REMOVE_COUNTRIES_GROUP = 'REMOVE_COUNTRIES_GROUP'

const SET_CLIENTS = 'SET_CLIENTS'
const UPDATE_CLIENT = 'UPDATE_CLIENT'

const SET_FILTERS = 'SET_FILTERS'
const RESET_FILTERS = 'RESET_FILTERS'

const SET_COUNTRIES_GROUP = 'SET_COUNTRIES_GROUP'
const UNSET_COUNTRIES_GROUP = 'UNSET_COUNTRIES_GROUP'

const SET_CLIENT = 'SET_CLIENT'
const UNSET_CLIENT = 'UNSET_CLIENT'

const SET_CLIENT_COMMENTS = 'SET_CLIENT_COMMENTS'
const ADD_CLIENT_COMMENT = 'ADD_CLIENT_COMMENT'

const SET_CLIENT_SCHEDULE_STATS = 'SET_CLIENT_SCHEDULE_STATS'
const SET_CLIENT_FARM_STATS = 'SET_CLIENT_FARM_STATS'

export default {
  namespaced: true,

  state () {
    return {
      filters: {},
      countriesGroups: [],
      clients: [],
      countriesGroup: null,
      client: null,
      clientComments: [],
      clientStats: {
        schedules: null,
        farms: null
      }
    }
  },

  getters: {
    countriesGroups: (state) => state.countriesGroups,
    clients: (state) => state.clients,
    totalCountriesGroupsCount: (state) => state.countriesGroups.count || 0,
    totalClientsCount: (state) => state.clients.count || 0,
    countriesGroupFilters: (state) => state.filters,
    countriesGroup: (state) => state.countriesGroup,
    client: (state) => state.client,
    clientComments: (state) => state.clientComments,
    clientStats: (state) => state.clientStats,
    uniqueCountriesGroups: (state) => {
      return state.countriesGroups.filter((item, index) => {
        return state.countriesGroups.findIndex(el => el.id === item.id) === index
      })
    },
    currentCountriesGroupClients: (state) => {
      if (!state.countriesGroup) return []
      return state.clients.filter(client => client.group_id === state.countriesGroup.id)
    }
  },

  mutations: {
    [SET_COUNTRIES_GROUPS] (state, data) {
      state.countriesGroups = data.filter((item, index) => {
        return data.findIndex(el => el.id === item.id) === index
      })
    },

    [ADD_COUNTRIES_GROUP] (state, data) {
      state.countriesGroups.unshift(data)
    },

    [UPDATE_COUNTRIES_GROUP] (state, data) {
      const index = state.countriesGroups.findIndex(item => item.id === data.id)
      if (index !== -1) {
        for (const key in data) {
          state.countriesGroups[index][key] = data[key]
        }
      }
    },

    [REMOVE_COUNTRIES_GROUP] (state, id) {
      state.countriesGroups = state.countriesGroups.filter(group => group.id !== id)
    },

    [SET_CLIENTS] (state, data) {
      state.clients = data.filter((item, index) => {
        return data.findIndex(el => el.id === item.id) === index
      })
    },

    [UPDATE_CLIENT] (state, data) {
      const index = state.clients.findIndex(item => item.id === data.id)
      if (index !== -1) {
        for (const key in data) {
          state.clients[index][key] = data[key]
        }
      }
    },

    [SET_FILTERS] (state, data) {
      state.filters = data
    },

    [RESET_FILTERS] (state) {
      state.filters = {}
    },

    [SET_COUNTRIES_GROUP] (state, data) {
      state.countriesGroup = data
    },

    [UNSET_COUNTRIES_GROUP] (state) {
      state.countriesGroup = null
    },

    [SET_CLIENT] (state, data) {
      state.client = data
    },

    [UNSET_CLIENT] (state) {
      state.client = null
    },

    [SET_CLIENT_COMMENTS] (state, data) {
      state.clientComments = data
    },

    [ADD_CLIENT_COMMENT] (state, data) {
      state.clientComments.unshift(data)
    },

    [SET_CLIENT_SCHEDULE_STATS] (state, data) {
      state.clientStats.schedules = data
    },

    [SET_CLIENT_FARM_STATS] (state, data) {
      state.clientStats.farms = data
    }
  },

  actions: {
    async loadCountriesGroups ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const { data, count } = await api.dashboard.groups.list(state.filters)
      commit(SET_COUNTRIES_GROUPS, data || [])
      return { data, count }
    },

    async setCountriesGroupFilters ({ commit, dispatch }, params = {}) {
      commit(SET_FILTERS, params)
      dispatch('loadCountriesGroups')
    },

    resetCountriesGroupFilters ({ commit, dispatch }) {
      commit(RESET_FILTERS)
      dispatch('loadCountriesGroups')
    },

    async createCountriesGroup ({ dispatch }, payload) {
      const { data, errors } = await api.dashboard.groups.create(payload)
      dispatch('loadCountriesGroups')
      return { errors, data }
    },

    getCountriesGroupDetail (context, id) {
      return api.dashboard.groups.getById(id)
    },

    async selectCountriesGroup (context, id) {
      const { data } = await context.dispatch('getCountriesGroupDetail', id)
      context.commit(SET_COUNTRIES_GROUP, data)
      return data
    },


    async updateCountriesGroup ({ commit, dispatch }, { id, payload }) {
      const { data, errors } = await api.dashboard.groups.updateById(id, payload)
      if (!errors) {
        commit(UPDATE_COUNTRIES_GROUP, data)
        // Перезавантажуємо список груп, щоб отримати свіжі дані
        dispatch('loadCountriesGroups')
      }
      commit(UNSET_COUNTRIES_GROUP)
      return errors
    },

    async deleteCountriesGroup ({ commit, dispatch, getters }) {
      const item = getters.countriesGroup
      await api.dashboard.groups.deleteById(item.id)
      dispatch('loadCountriesGroups')
      commit(UNSET_COUNTRIES_GROUP)
    },

    unsetCountriesGroup ({ commit }) {
      commit(UNSET_COUNTRIES_GROUP)
    },

    // Clients actions
    async loadClients ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const { data, count } = await api.dashboard.groups.getClients(state.filters)
      commit(SET_CLIENTS, data || [])
      return { data, count }
    },

    getClientDetail (context, id) {
      return api.dashboard.groups.getClientById(id)
    },

    async selectClient (context, id) {
      const { data } = await context.dispatch('getClientDetail', id)
      context.commit(SET_CLIENT, data)
      return data
    },

    async updateClient ({ commit, getters }) {
      const item = getters.client
      const { data, errors } = await api.dashboard.groups.updateClientById(item.id, item)
      commit(UPDATE_CLIENT, data)
      commit(UNSET_CLIENT)
      return errors
    },

    unsetClient ({ commit }) {
      commit(UNSET_CLIENT)
    },

    // Comments actions
    async loadClientComments ({ commit }, { userId, params = {} }) {
      const { data } = await api.dashboard.groups.getClientComments(userId, params)
      commit(SET_CLIENT_COMMENTS, data || [])
      return data
    },

    async createClientComment ({ commit }, { userId, payload }) {
      const { data, errors } = await api.dashboard.groups.createClientComment(userId, payload)
      if (data) {
        commit(ADD_CLIENT_COMMENT, data)
      }
      return { errors, data }
    },

    // Statistics actions
    async loadClientScheduleStats ({ commit }, { userId, params = {} }) {
      const { data } = await api.dashboard.groups.getClientScheduleStats(userId, params)
      commit(SET_CLIENT_SCHEDULE_STATS, data)
      return data
    },

    async loadClientFarmStats ({ commit }, { userId, params = {} }) {
      const { data } = await api.dashboard.groups.getClientFarmStats(userId, params)
      commit(SET_CLIENT_FARM_STATS, data)
      return data
    }
  }
}
